import React from "react";
import "../css/vehicle.css";
import AdNav from "../components/adNav";
import Time from "../components/time";
import { Link } from "react-router-dom";


const FileManager = () => {
  return (
    <div id="admin-container">
      <AdNav />
      <div className="content-right">
        <section>
          <h2 className="add-txt">File Manager
          </h2>
          <Time />
        </section>

     <div className="container">
      <table className="transaction-table ">
        <thead>
          <tr>
            <th className="table-header">Welcome Admin</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td><Link to="/admin/add_fileheading">Title Manager</Link></td>
          </tr>
          <tr>
            <td><Link to="/admin/file_listing">Upload Your Files</Link></td>
          </tr>
        </tbody>
      </table>
      </div>
    </div>
    </div>
  );
};

export default FileManager;
